import React from 'react';
import uuidv1 from 'uuid/v1';
// APOLLO
import { graphql, compose } from 'react-apollo';
import lineItemsQuery from 'ApolloClient/Queries/lineItems';
// ANTD
import Form from 'antd/lib/form';
import Row from 'components/common/Row';
import Button from 'components/common/Button';
import Col from 'components/common/Col';
import SavedLineItemsInput from 'components/inputs/SavedLineItemsInput';
import 'antd/lib/form/style/css';

// CONSTANTS AND DESTRUCTURING
// ================================================================
const FormItem = Form.Item;

// EXPORTED COMPONENT
// ================================================================

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
  },
};

class SavedLineItemsForm extends React.Component {
  state = {
    lineItem: null,
  };

  onSelectChange = lineItem => {
    this.setState({ lineItem });
  };

  onAdd = () => {
    const { keys } = this.props;
    let lineItem = this.state.lineItem;
    let randomKey = uuidv1();
    const getNewKeys = () => {
      let keysCopy = keys;
      keysCopy.push(randomKey);
      return keysCopy;
    };
    let lineItemToAdd = {
      [`names-${randomKey}`]: {
        description: lineItem.description,
        amount: lineItem.amount,
      },
      keys: getNewKeys(),
    };
    this.props.onChange(lineItemToAdd);
    this.setState({ lineItem: null });
  };

  render() {
    const { loading, lineItems } = this.props.lineItemsQuery;

    if (loading) {
      return <div style={{ minHeight: 100 }}>LOADING...</div>;
    }

    return (
      <FormItem {...formItemLayout} label={<span>Add Pricing</span>}>
        <Row type="flex" align="middle" justify="center">
          <Col xs={23} sm={22}>
            <Row gutter={20}>
              <Col xs={16} sm={19}>
                <SavedLineItemsInput
                  onSelectChange={this.onSelectChange}
                  lineItems={lineItems}
                  currencySymbol={this.props.currencySymbol}
                  currentLineItemId={this.state.lineItem && this.state.lineItem._id}
                />
              </Col>
              <Col xs={8} sm={5}>
                <Button
                  type={!this.state.lineItem ? 'dashed' : 'primary'}
                  onClick={this.onAdd}
                  fullWidth
                  disabled={!this.state.lineItem}
                >
                  + ADD
                </Button>
              </Col>
            </Row>
          </Col>
          <Col xs={1} sm={2} />
        </Row>
      </FormItem>
    );
  }
}

export default compose(graphql(lineItemsQuery, { name: 'lineItemsQuery' }))(SavedLineItemsForm);



// WEBPACK FOOTER //
// ./src/components/forms/SavedLineItemsForm/index.js